import React, { createContext, useState } from "react";

// ✅ Create the context
export const ClientContext = createContext();

// ✅ Create the provider component
export const ClientProvider = ({ children }) => {
     const [clientLocations, setClientLocation] = useState([]);

     const updateClientlocation = (account) => setClientLocation(account);

     return (
          <ClientContext.Provider
               value={{
                    clientLocations,
                    updateClientlocation,
               }}
          >
               {children}
          </ClientContext.Provider>
     );
};

